import React from 'react';
import styled from 'styled-components';

import { AccordionBanner } from 'src/payments/components/accordion-banner/accordion-banner';
import { CashBackDetails } from 'src/payments/components/cash-back-details';
import { accordionFullWidthReset } from 'src/payments/components/incentive-accordion-styles/incentive-accordion-styles';
import MultiDiscount from 'src/payments/components/pbb-incentive-banner/assets/multi-discount';
import type { ValidIncentiveValue } from 'src/payments/hooks/shared/incentive-types';

type CashBackIncentiveBannerProps = {
  className?: string;
  marginBottom?: string;
  paymentStepText?: string;
  value: ValidIncentiveValue;
  minimumOrderTotalDisplay: string;
};

export const CashBackIncentiveBanner = ({
  className,
  marginBottom,
  paymentStepText,
  value,
  minimumOrderTotalDisplay,
}: CashBackIncentiveBannerProps): JSX.Element => {
  const headline = (
    <span>
      Get <strong>${value} back</strong> on your first {minimumOrderTotalDisplay}+ order paid by bank.{' '}
      <u>Terms Apply.</u>
    </span>
  );

  return (
    <StyledAccordionBanner
      className={className}
      marginBottom={marginBottom}
      borderRadius='4px 4px 4px 4px'
      graphic={<MultiDiscount amount={value} />}
      mainContent={headline}
      toggleContent={
        <CashBackDetails
          value={value}
          paymentStepText={paymentStepText}
          minimumOrderTotalDisplay={minimumOrderTotalDisplay}
        />
      }
    />
  );
};

const StyledAccordionBanner = styled(AccordionBanner)`
  &.MuiPaper-root {
    ${accordionFullWidthReset}
  }

  & > .MuiCollapse-container {
    border-top: 1px solid var(--dcm-cash-back-incentive-banner-border-color, #8fcfc0);
  }
`;
